import React from 'react';
import { Presentation } from './pages/Presentation';
interface AppProps {
  /** Show the step progress rail inside the mobile Snak. */
  showProgress?: boolean;
  /** Let the "Families are funny" interlude play itself, or require a tap per line. */
  autoplayInterlude?: boolean;
}
export function App({
  showProgress = true,
  autoplayInterlude = true
}: AppProps) {
  return <Presentation showProgress={showProgress} autoplayInterlude={autoplayInterlude} data-id="element-0" data-mp="3f8n9p58z6n28" />;
}